/**
 * Gets the origin of the provided URL
 * @param url URL whose origin is to be extracted
 */
export function getOrigin(url: string): string {
  return new URL(url).origin;
}
